import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
    instanceKeycloak: any;
    userInfo: Observable<any>;

    constructor(private keycloakService: KeycloakService) {}

    ngOnInit() {
        this.instanceKeycloak = this.keycloakService.getKeycloakInstance();
        this.userInfo = this.instanceKeycloak.loadUserProfile();
    }

    logout = () => this.keycloakService.logout();
}
